export const convertQueryParamsStringToQueryParamsObject = (url: string) => {
  url = url.substring(1);
  const queryParamsArray = url.split("?");
  return queryParamsArray[1].split("=")[1];
};
